module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/medical.90f87f37.svg";